import React, { useState } from 'react';
import useToggle from '../../Hooks/useToggle';
import { Modal } from 'react-bootstrap';
import { importExcel } from '../../utils/Excel/importExcel';
import axios from 'axios';
import toast from 'react-hot-toast';

const AdminInsignias = () => {

    const [modal, toggleModal] = useToggle(false)

    return (
        <>
            <main className='container' id="admin">
                <br /><br />
                <div className='card border-radius mt-5'>
                    <div className='card-body p-5'>
                        <h5 className='text-center'>Cargar Insignias</h5>
                        <div className='row justify-content-center'>
                            <div className='col-12 col-md-6 col-lg-6'>
                                <button className='btn-aprove' onClick={toggleModal}>Subir Excel para cargar Insignias</button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <ModalAdd show={modal} toggleModal={toggleModal} />
        </>
    );
};


function ModalAdd({show, toggleModal}) {

    const [file, setFile] = useState(null)
    const [medals, setMedals] = useState([])

    const [etapas, setEtapas] = useState({
        current: 1,
        max: 4,
        min: 1
    })

    function nextStep() {
        if(etapas.current >= etapas.min && etapas.current < etapas.max ) {
            setEtapas({
                ...etapas,
                current: etapas.current + 1
            })
        }
    }

    function backStep() {
        if(etapas.current > etapas.min && etapas.current <= etapas.max ) {
            setEtapas({
                ...etapas,
                current: etapas.current - 1
            })
        }
    }

    function getTypeMedal(type = "") {
        switch (type.toLowerCase()) {
            case "alpha":
                return 1
        
            case "beta":
                return 2
            default:
                return 3
        }
    }

    function formatter(data = []) {

        return data.map((elm) => {
            return {
                userReceiverId: elm.userid,
                nota: elm.nota,
                typeMedalId: getTypeMedal(elm.tipo)
            }
        })
    }

    function importMedals() {

        toast("Importando insignias");

        axios.post("medal/massive", medals)
        .then(() => {
            toast.success("Insignias importadas")
            toggleModal()
            setEtapas({
                ...etapas,
                current: 1
            })
        })
        .catch(() => toast.error("Error al importar insignias"))
    }


    return (
        <>
            <Modal show={show} onHide={toggleModal} className="kr-modal">
                <Modal.Header>Subir Insignias</Modal.Header>

                <Modal.Body>
                    { etapas.current === 1 &&
                        <>
                            <h2>Estructura del archivo</h2>

                            <table className='table table-striped table-bordered table-success'>
                                <thead>
                                    <tr>
                                        <th>userid</th>
                                        <th>tipo</th>
                                        <th>nota</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>{Math.floor(Math.random() * 100)}</td>
                                        <td title='tiene que ser en minuscula'>alpha</td>
                                        <td>Por completar el curso (X)</td>
                                    </tr>

                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>

                            <button className='btn-deg' onClick={nextStep}>
                                Siguiente
                            </button>
                        </>
                    }

                    { etapas.current === 2 &&
                        <>
                            <h2>Seleccione el archivo excel</h2>

                            <div className='form-group mb-5'>
                                <input type='file' className='form-control' onChange={({target}) => setFile(target.files[0] ?? null)} />
                            </div>

                            <div className='d-flex'>
                                <button onClick={backStep} className="btn-deg mx-2" style={{background: "grey", color: "#000"}}>Atras</button>
                                <button onClick={() => {
                                    if(file !== null) {
                                        importExcel(file)
                                        .then((data) => setMedals(formatter(data)) )
                                        .finally(() => nextStep())
                                    }
                                }} className="btn-deg mx-2">Siguiente</button>
                            </div>
                        </>
                    }

                    { etapas.current === 3 &&

                        <>
                            <h2>Ver datos a importar</h2>

                            <table style={{maxHeight: "60vh", overflowY: "auto"}} className='table table-bordered table-stripe table-success'>
                                <thead>
                                    <tr>
                                        <th>userid</th>
                                        <th>tipo</th>
                                        <th>nota</th>
                                    </tr>
                                </thead>


                                <tbody>
                                    {medals.map((elm, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>{elm.userReceiverId}</td>
                                                <td>{elm.typeMedalId}</td>
                                                <td>{elm.nota}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>

                                
                            </table>

                            <div className='d-flex'>
                                <button onClick={backStep} className="btn-deg mx-2" style={{background: "grey", color: "#000"}}>Atras</button>
                                <button onClick={importMedals}   className="btn-deg mx-2">Importar</button>
                            </div>
                        </>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AdminInsignias;